import type { FormData } from "../types";
import { LESSON_TYPE_OPTIONS, DIFFICULTY_OPTIONS } from "../constants";

interface LessonTypeSectionProps {
  formData: FormData;
  onFormChange: (field: keyof FormData, value: any) => void;
}

export function LessonTypeSection({
  formData,
  onFormChange,
}: LessonTypeSectionProps) {
  return (
    <div className="md:col-span-2">
      <label
        className="block text-sm font-medium mb-3"
        style={{ color: "var(--text-primary)" }}
      >
        Tipo de Aula *
      </label>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {LESSON_TYPE_OPTIONS.map((type) => {
          const Icon = type.icon;
          return (
            <button
              key={type.value}
              type="button"
              onClick={() => onFormChange("lessonType", type.value)}
              className={`p-4 rounded-xl border-2 transition flex flex-col items-center gap-2 ${
                formData.lessonType === type.value
                  ? "border-(--primary-color) bg-(--bg-accent)"
                  : "border-(--border-color) hover:border-(--primary-hover) bg-(--card-bg)"
              }`}
            >
              {Icon && (
                <Icon
                  className="w-5 h-5"
                  style={{
                    color:
                      formData.lessonType === type.value
                        ? "var(--primary-color)"
                        : "var(--text-tertiary)",
                  }}
                />
              )}
              <span
                className="text-sm font-medium"
                style={{
                  color:
                    formData.lessonType === type.value
                      ? "var(--primary-color)"
                      : "var(--text-primary)",
                }}
              >
                {type.label}
              </span>
            </button>
          );
        })}
      </div>

      <div className="mt-6">
        <label
          className="block text-sm font-medium mb-3"
          style={{ color: "var(--text-primary)" }}
        >
          Nível de Dificuldade *
        </label>
        <div className="flex gap-2">
          {DIFFICULTY_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onFormChange("difficulty", option.value)}
              className={`flex-1 p-3 rounded-lg border text-center transition ${
                formData.difficulty === option.value
                  ? "border-(--primary-color) bg-(--bg-accent)"
                  : "border-(--border-color) hover:border-(--primary-hover)"
              }`}
              style={{
                color:
                  formData.difficulty === option.value
                    ? "var(--primary-color)"
                    : "var(--text-primary)",
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
